<template>
  <li class="[ c-cookie-banner__checkbox-item ]">
    <div class="[ c-cookie-banner__checkbox-container ]"
         v-bind:class="isEssentialCookies">
      <input v-if="listType === 'essential'"
             :id="listType"
             class="[ c-cookie-banner__checkbox ]"
             v-bind:class="isDisabled"
             type="checkbox"
             v-model="checkAll"
      />
      <input v-else
             :id="listType"
             class="[ c-cookie-banner__checkbox ]"
             v-bind:class="isDisabled"
             type="checkbox"
             v-model="checkAll"
             v-indeterminate="checkedCookies"
      />
      <label :for="listType"
             class="[ c-cookie-banner__checkbox-label ]"
             v-html="$t('banner.' + listType + '.label')"/>
    </div>
    <div v-if="visibleDetails" class="[ c-cookie-banner__cookie-content ]">
      <p class="[ c-cookie-banner__category-description ]" v-html="$t('banner.' + listType + '.description')"/>
      <button type="button" class="[ c-cookie-banner__details-button ]"
            v-on:click="isCookieDetail = !isCookieDetail"
            v-html="$t('banner.' + listType + '.action')"/>
      <div v-if="isCookieDetail" class="[ c-cookie-banner__cookie-list ]">
        <div :key="index" v-for="(cookie, index) in cookieList">
          <div class="[ c-cookie-banner__cookie-item ]">
            <div class="[ c-cookie-banner__cookie-name ]"
                 v-on:click="cookie.showDetails = !cookie.showDetails">
              <i class="[ c-chevron ]  [ c-cookie-banner__cookie-icon ]"
                 v-bind:class="{'c-cookie-banner__cookie-icon--checked': cookie.showDetails}"/>
              <span v-html="cookie.name"/>
            </div>
            <div class="[ c-cookie-banner__cookie-description ]">
              <p class="[ c-cookie-banner__description ]"
                 v-on:click="cookie.showDetails = !cookie.showDetails"
                 v-html="cookie[language]['shortDescription']"/>
              <p class="[ c-cookie-banner__description-long ]" v-if="cookie.showDetails"
                    v-html="cookie[language]['description']"/>
            </div>
            <div class="[ c-cookie-banner__cookie-checkbox ]">
              <input :id="'cookie-'+ listType + '-' + index"
                     class="[ c-cookie-banner__checkbox  ]"
                     v-bind:class="isDisabled"
                     type="checkbox"
                     v-model="checkedCookies"
                     :value="cookie"
                     :disabled="isEssential"
              />
              <label :for="'cookie-'+ listType+ '-' + index"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'CookieList',
  props: {
    listType: String,
    language: String,
    cookieList: Array,
    showDetails: Boolean
  },
  beforeMount: function () {
    this.checkEssentialList()
  },
  data: function () {
    return {
      isCookieDetail: false,
      isChecked: false,
      checkedCookies: []
    }
  },
  directives: {
    indeterminate: function (el, binding, vnode) {
      el.indeterminate = binding.value.length > 0 && vnode.context.checkAll && !el.checked
      el.checked = binding.value.length > 0
    }
  },
  computed: {
    checkAll: {
      get: function () {
        return this.cookieList
          ? this.checkedCookies.length === this.cookieList.length
          : false
      },
      set: function (value) {
        const checked = []

        if (value) {
          this.cookieList.forEach(function (cookie) {
            checked.push(cookie)
          })
        }
        this.checkedCookies = checked
      }
    },
    visibleDetails: function () {
      return this.showDetails
    },
    isEssentialCookies: function () {
      return {
        'c-cookie-banner__checkbox-container--disabled':
            this.isEssential
              ? 'c-cookie-banner__checkbox-container--disabled'
              : ''
      }
    },
    isEssential: function () {
      return this.listType === 'essential'
    },
    isDisabled: function () {
      return this.isEssential
        ? 'c-cookie-banner__checkbox--disabled c-cookie-banner__checkbox-container--disabled'
        : ''
    }
  },
  methods: {
    checkEssentialList: function () {
      if (this.isEssential) {
        const checked = []

        this.cookieList.forEach(function (cookie) {
          checked.push(cookie)
        })

        this.checkedCookies = checked
      }
    }
  }
}
</script>
